import React from "react"
import footerStyle from "./footer.module.scss"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faFacebook,
  faInstagram,
  faYelp,
} from "@fortawesome/free-brands-svg-icons"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

library.add(faFacebook, faInstagram, faYelp)

const Footer = () => {
  return (
    <footer className={footerStyle.footer}>
      <ul className={footerStyle.ul}>
        <li>
          <a href="https://www.instagram.com/meltcafe234/" target="_blank">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/meltcafeclarksburg/"
            target="_blank"
          >
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        </li>
        <li>
          <FontAwesomeIcon icon={faYelp} />
        </li>
      </ul>
    </footer>
  )
}

export default Footer
